import focusInputByName from "./focusInputByName";

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ data = {}, except = [], setFocus }) {
  const keys = Object.keys(data);

  if (keys.length === 0) {
    document.getElementsByTagName("input")[0].focus();
    return false;
  }
  for (const item of keys) {
    const found = except.find((i) => i === item);
    if (found) return true;
    if (!data[item] || data[item] === "") {
      focusInputByName(item);
      return false;
    }
  }
  return true;
}
